import { combineReducers } from 'redux'
import auth from './auth'
import list from './auth/listSlice'
import notification from './auth/notificationSlice'
import locale from './locale/localeSlice'
import admin from './admin'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        list,
        notification,
        locale,
        admin,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
